/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
type RewardsNav_user$ref = any;
export type Rewards_user$ref = any;
export type Rewards_user = {
    readonly isVerifiedTrade: boolean | null;
    readonly " $fragmentRefs": RewardsNav_user$ref;
    readonly " $refType": Rewards_user$ref;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "Rewards_user",
  "type": "User",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "isVerifiedTrade",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "FragmentSpread",
      "name": "RewardsNav_user",
      "args": null
    }
  ]
};
(node as any).hash = 'aa3172776739dc69e0a28b1972c45cb4';
export default node;
